import { Loading } from "@repo/ui";
import { useEffect } from "react";

import { useRepDisciplineApi } from "../../../../api/repDisciplineApi";
import {
	RepDisciplinesProvider,
	RepProvider,
	useRepContext,
	useRepDisciplineContext,
} from "../../../../contexts/editableItemContext";
import { PendingChangesProvider } from "../../../../contexts/pendingChangesContext";
import { Rep } from "../../../../models";
import RepDisciplineEditorDynamic from "../../../disciplines/editor";

export function RepDisciplineEditorModal(props: Props) {
	const { rep, onClose } = props;
	return (
		<PendingChangesProvider>
			<RepProvider item={{ ...rep }}>
				<RepDisciplinesProvider>
					<RepDisciplineEditorModalInternal {...props} onClose={onClose} />
				</RepDisciplinesProvider>
			</RepProvider>
		</PendingChangesProvider>
	);
}

interface Props {
	rep: Rep;
	incidentId: number;
	onModalSave: () => Promise<void>;
	onClose?: () => void;
}

export function RepDisciplineEditorModalInternal(props: Props) {
	const { incidentId, onModalSave, onClose } = props;

	const { item: repDiscipline, overwriteItem } = useRepDisciplineContext();
	const { repId } = useRepContext();
	const { getRepDisciplinesOnIncident } = useRepDisciplineApi();

	useEffect(() => {
		getRepDiscipline();
	}, []);

	async function getRepDiscipline() {
		const discipline = await getRepDisciplinesOnIncident(repId, incidentId);
		overwriteItem({ ...discipline });
	}

	async function postSave() {
		await onModalSave();
		onClose?.();
	}

	return (
		<Loading loading={!repDiscipline}>
			<RepDisciplineEditorDynamic postSave={postSave} />
		</Loading>
	);
}
